// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"WA-z","giftOrPromoSelector":"XA-z","disabled":"YA-z","subTitle":"ZA-z","selectShipAddressMessage":"_A-z","changePayment":"aB-z"};